/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'minus': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 2.93',
    data: '<path pid="0" d="M0 0h24v2.93H0z"/>'
  }
})
